import React, { useState, useEffect, useCallback } from "react";
import './DataTable.css';

export default function DataTableDropdown(props) {
  const [label, setLabel] = useState("");
  const [dropdownFilterData, setDropdownFilterData] = useState([]);

  useEffect(() => {
    if (props?.label) {
      setLabel(props?.label);
    }
  }, [props?.label]);

  useEffect(() => {
    if (props?.dropdownFilterData) {
      setDropdownFilterData(props?.dropdownFilterData);
    }
  }, [props?.dropdownFilterData]);

  return (
    <div className={`align-items-center bg-white ${props?.className}`}>
      <div className="w-100">
        <div className="d-flex" style={{ flexDirection: "column" }}>
          {props?.label !== undefined && props?.label !== null && (
            <label className="">{label}:</label>
          )}
          <div className="dropdown dropdown-inline show data_table_main_dropdown">
          <button
              type="button"
              tabIndex="-1"
              data-toggle="dropdown"
              role="combobox"
              className="btn dropdown-toggle btn-light bs-placeholder data_table_dropdown_button dropdown-button"
              aria-owns="bs-select-1"
              aria-haspopup="listbox"
              aria-expanded="false"
              data-id="kt_datatable_search_status"
              title={props.placeholder}
            >
              <div className="filter-option" style={{ overflow: "hidden" }}>
                <div className="filter-option-inner">
                  <div className="filter-option-inner-inner">
                    {
                      dropdownFilterData.find((val) => val.isSelected === true)?.name ||
                      props.placeholder // Display the placeholder value if no option is selected
                    }
                  </div>
                </div>
              </div>
            </button>


            <div
              className="dropdown-menu dropdown-menu-sm dropdown-menu-right data_table_main_dropdown_menu"
              style={{
                width: "100%",
                minWidth: "175px",
                maxHeight: "450px",
                overflow: "auto",
                position: "absolute",
                willChange: "transform",
                top: "0px",
                left: "0px",
                transform: "translate3d(0px, 40px, 0px)",
              }}
              x-placement="bottom-end"
            >
              <ul className="navi flex-column navi-hover py-2">
                {dropdownFilterData.map((optionItem, i) => (
                  <li className="navi-item" key={i} value={optionItem._id}>
                    <a
                      className={`navi-link ${
                        optionItem.isSelected ? "active" : ""
                      } data_table_dropdown_item_active`}
                      onClick={() => {
                        let temp = [...dropdownFilterData];

                        for (let i = 0; i < temp.length; i++) {
                          if (temp[i].name === optionItem.name)
                            temp[i].isSelected = true;
                          else temp[i].isSelected = false;
                        }

                        props.onClickSetDropdownFilterData(temp);
                      }}
                    >
                      <span className="navi-text">{optionItem.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <>
              {/* <div className="dropdown-menu show data_table_main_dropdown_menu"
                x-placement="bottom-start">
                <div className="inner show data_table_main_dropdown_inner" role="listbox" id="bs-select-1" tabIndex="-1" aria-activedescendant="bs-select-1-0">
                  <ul className="dropdown-menu inner show data_table_main_dropdown_inner_ul" role="presentation">
                    <li className="selected active">
                      <a role="option" className="dropdown-item active selected" id="bs-select-1-0" tabIndex="0" aria-setsize="7" aria-posinset="1" aria-selected="true">
                        <span className="text">
                          All
                        </span>
                      </a>
                    </li>
                    <li className="">
                      <a role="option" className="dropdown-item" id="bs-select-1-1" tabIndex="0" aria-setsize="7" aria-posinset="2">
                        <span className="text">
                          Pending
                        </span>
                      </a>
                    </li>
                    <li>
                      <a role="option" className="dropdown-item" id="bs-select-1-2" tabIndex="0" aria-setsize="7" aria-posinset="3">
                        <span className="text">
                          Delivered
                        </span>
                      </a>
                    </li>
                    <li>
                      <a role="option" className="dropdown-item" id="bs-select-1-3" tabIndex="0" aria-setsize="7" aria-posinset="4">
                        <span className="text">
                          Canceled
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
            </>
          </div>
        </div>
      </div>
    </div>
  );
}
